"use strict";
import {
  isArrayBuffer,
  isArrayBufferView,
  isBlob,
  isBuffer,
  isFile,
  isFormData,
  isURLSearchParams,
  isHeaders
} from "../../helper";
const CONTENT_TYPE_KEY = ["Content-Type", "content-type"];
const setContentTypeIfUnset = (headers, value) => {
  if (isHeaders(headers)) {
    if (!headers.has(CONTENT_TYPE_KEY[0]) && !headers.has(CONTENT_TYPE_KEY[1])) {
      headers.append(CONTENT_TYPE_KEY[0], value);
    }
  } else if (!headers[CONTENT_TYPE_KEY[0]] && !headers[CONTENT_TYPE_KEY[1]]) {
    headers[CONTENT_TYPE_KEY[0]] = value;
  }
};
const hasContentType = (headers) => {
  if (isHeaders(headers)) {
    if (headers.has(CONTENT_TYPE_KEY[0]) || headers.has(CONTENT_TYPE_KEY[1])) {
      return true;
    }
  } else if (headers[CONTENT_TYPE_KEY[0]] || headers[CONTENT_TYPE_KEY[1]]) {
    return true;
  }
  return false;
};
const optionsParser = function(ctx, next) {
  const { req } = ctx;
  if (!req.method) {
    req.method = "GET";
  } else {
    req.method = req.method.toUpperCase();
  }
  if (!req.headers) {
    req.headers = {};
  }
  const { method } = req;
  const body = req.data || req.body;
  if (method !== "GET") {
    switch (true) {
      case hasContentType(req.headers):
      case isFormData(body):
        req.body = body;
        break;
      case isBlob(body):
      case isFile(body):
      case isBuffer(body):
      case isArrayBuffer(body):
      case isArrayBufferView(body):
      case isURLSearchParams(body):
        setContentTypeIfUnset(req.headers, "multipart/form-data");
        req.body = body;
        break;
      default:
        setContentTypeIfUnset(req.headers, "application/json");
        req.body = JSON.stringify(body);
        break;
    }
  }
  if (req.withCredentials === void 0) {
    req.withCredentials = true;
  }
  if (req.credentials === void 0) {
    req.credentials = "same-origin";
  }
  return next();
};
export default optionsParser;
//# sourceMappingURL=optionsParser.js.map
